import * as React from 'react';
import i18n from '@i18next/i18n';
import { MobileContextMenuConfig } from '@tencent/workbench';
import longPressCopyIcon from '@tencent/docs-design-resources/mobile/svg/longpress_icon_moveforward.svg';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { RegionType } from '@src/slide/domain/selection/constant/region';

export const config = {
    name: ActionType.MOVE_SLIDE_UP,
    content: i18n.t<string>('前移'),
    tooltip: i18n.t<string>('前移'),
    icon: <img src={longPressCopyIcon} />,
    showRegions: [RegionType.SLIDELIST],
};


export const MOBILE_CONTEXTMENU_ITEMS: MobileContextMenuConfig[] = [
    config,
];
